var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#2D1664"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 15.5H5.5675L8.82833 12.705L8 12L3.33333 16L8 20L8.82249 19.295L5.5675 16.5H12.6667V15.5Z",
    fill: "#F1F0F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.99935L12.705 8.82185L15.5 5.56685L15.5 12.666L16.5 12.666L16.5 5.56685L19.295 8.82185L20 7.99935L16 3.33268L12 7.99935Z",
    fill: "#F1F0F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 16.5L26.4325 16.5L23.1717 19.295L24 20L28.6667 16L24 12L23.1775 12.705L26.4325 15.5L19.3333 15.5L19.3333 16.5Z",
    fill: "#F1F0F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24.0007L19.295 23.1782L16.5 26.4332L16.5 19.334L15.5 19.334L15.5 26.4332L12.705 23.1782L12 24.0007L16 28.6673L20 24.0007Z",
    fill: "#F1F0F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIcon);
export default __webpack_public_path__ + "static/media/move-icon.caa25b1853a28b1b4f0b6a63b09087b5.svg";
export { ForwardRef as ReactComponent };